import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { News } from '../../models/news';
import { NewsDetail } from '../../models/newsDetail';
import { PlanoneService } from '../../plan/planone/services/planone.service';
import { PlanthreeService } from '../../plan/planthree/services/planthree.service';
import { PlantwoService } from '../../plan/plantwo/services/plantwo.service';
import { PlanMainService } from '../../plan/service/plan-main.service';
import { DataService } from '../../services/data.service';
import { LoginService } from '../../services/login.service';
import { NewsService } from '../../services/news.service';
import { PlanService } from '../../services/plan.service';
import { UtilService } from '../../services/util.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
  // encapsulation: ViewEncapsulation.Native
})
export class HomeComponent implements OnInit, OnDestroy {
  public salePlanEdit: number;
  public openDialog = false;
  public showEstimates = false;
  public showDialogOrder = false;
  public display = false;
  public display2 = false;
  public staffCheck: boolean;
  // @ViewChild('display') display: boolean = false;
  // @ViewChild('display2') display2: boolean = false;
  public news: News[] = [];
  public newsdetail: NewsDetail;
  public shownew = false;
  public page = 1;
  private ngUnsubscribe = new Subject();
  public menuAuthority: any;
  public showDialog: boolean = false;
  public errMsg: string = '';
  public resStatus: number;
  public openDialogStock = false;
  public showNewsDetail: boolean = false;
  public newsList: any;
  public newsPage: number = 1;
  public totalPages: number = 0;
  public showNews: any;
  public countNews: number = 0;
  public loader: boolean = false;
  public textContent1: string = "";
  public textContent2: string = "";
  public textContent3: string = "";
  public newcarText: string = "予算、ほしい車の条件から、<br>ピッタリの車を探せます！<br>メーカー、車種、グレード、価格、ボディタイプ、<br>燃費など、各種条件検索あり。";
  public planText: string = "商談を再開する場合や注文書情報の<br>更新をしたい時はコチラへ。<br>見積・ 注文書それぞれ検索が可能です。";
  public stockText: string =  "自社の中古車在庫の中から車を検索して、<br>見積作成、注文書印刷ができます。";
  public menuSetting: any = {
    "ncIchibaState": 3,
    "ucLeaseState": 3,
    "ncDeliveryState": 3
  };

  constructor(
    private loginService: LoginService,
    private router: Router,
    private _planmainService: PlanMainService,
    private planService: PlanService,
    private newsService: NewsService,
    private _PlanoneService: PlanoneService,
    private _PlantwoService: PlantwoService,
    private _PlanthreeService: PlanthreeService,
    private _data: DataService,
    private _util: UtilService
  ) {
    this.staffCheck = false;
  }

  ngOnInit() {
    // this.planService.getEnvironmentSetting().subscribe(
    //   (response) => {
    //     localStorage.setItem('prefCd', response.prefCd.toString());
    //     // this.planService.chosenPrefCd.next(response.prefCd);
    //   });
    this.resetDataservice();
    // localStorage.removeItem('kyotenCd');
    // localStorage.removeItem('kyotenNm');
    // localStorage.removeItem('staffCd');
    // localStorage.removeItem('staffNm');
    // localStorage.removeItem('mitsumorino');
    // this.planService.behaviorNextnull();

    // this._planmainService.staffDialogCallback.next(null);
    // this._planmainService.staffDialog.next(null);

    // this.newsService.getNews(this.page).subscribe(data => {
    //   this.news = data.newslist;
    // });
    this.planService.jibaisekiObject.next(null);
    this._planmainService.taxvaluedata.next(null);
    this.getNewsList();
    this.newsService.isReload
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.getNewsList();
          this.newsService.isReload.next(false);
        }
      }
    );
    // const newisStafflogin = this._data.staffData; // JSON.parse(localStorage.getItem('staffData'));
    // if (newisStafflogin) {
    //   this._planmainService.staffDialogCallback.next(true);
    // }
    this.getHomeMenu();
    this._data.kyotenCdUpdate
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.getHomeMenu();
          this._data.kyotenCdUpdate.next(false);
        }
    });
  }

  getHomeMenu() {
    this.newsService.getHomeMenu()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.menuSetting = res;
        }
      }
    );
  }

  logout() {
    this.loginService.checkLogout().subscribe();
    this.router.navigate(['login']);
  }

  onrouterSalesPage() {
    this.router.navigate(['/sales']);
  }

  getStaffres(e) {
    this.staffCheck = e;
    if (e === false) {
      this._planmainService.staffDialog.next(null);
    }
  }

  checkStaffLogin(isClick: string, isUsedCar?: number) {
    this._planmainService.staffDialogCallback.next(null);
    this._planmainService.isPageLogin.next(isClick);
    if (isUsedCar !== null || isUsedCar !== undefined) {
      this.planService.getPlanUsedcar(isUsedCar);
    }
    if (isUsedCar === 1) {
      this.planService.productKbn.next(1);
    } else {
      this.planService.productKbn.next(0);
    }
    const isStafflogin = this._data.staffData;
    const token = this._data.token;

    if (isStafflogin && token) {
      this._planmainService.getMenuAuthority().subscribe(
        (res: any) => {
          if (res) {
            this.menuAuthority = res;
            this._planmainService.setMenuAutho(this.menuAuthority);
            // this.resStatus = this._planmainService.ResponseStatus;
            // this._planmainService.staffDialogCallback.next(true);

            if (res.status === 204) {
              this.errMsg = '担当者ログインが行われていません。';
              this.showDialog = true;
            } else {
              this.openAfterLogin(res, isClick);
            }
            // this.showDialog = false;
            // this.planmainService.staffDialogCallback.next(null);
            // this.planmainService.menuAuthoCallback.next(true);
          }
        },
        err => {
          this.errMsg = 'システムエラーが発生しました。';
          this.showDialog = true;
        }
      );
      // this.openDialog = true;
      // this.onrouterpage();
    } else {
      this.router.navigate(['/planmain']);
      this._planmainService.staffDialogCallback
        .takeUntil(this.ngUnsubscribe)
        .subscribe(e => {
          if (e) {
            this._planmainService.getMenuAuthority().subscribe((res: any) => {
              if (res) {
                if (res.status === 204) {
                  this.errMsg = '担当者ログインが行われていません。';
                  this.showDialog = true;
                } else {
                  this.openAfterLogin(res, isClick);
                }
              }
            });
          }
        });
    }
  }

  // toFukusha() {
  //   this._planmainService.staffDialogCallback.next(null);
  //   const isStafflogin = this._data.staffData;
  //   const token = this._data.token;
  //   if (isStafflogin && token) {
  //     this.router.navigate(['/osusume']);
  //     // this._planmainService.staffDialogCallback.next(true);
  //     // this.openDialog = true;
  //     // this.onrouterpage();
  //     this._planmainService.getMenuAuthority().subscribe((res: any) => {
  //       if (res) {
  //         this.menuAuthority = res;
  //         this._planmainService.setMenuAutho(this.menuAuthority);
  //         // this.resStatus = this._planmainService.ResponseStatus;
  //         this._planmainService.staffDialogCallback.next(true);

  //         if (this.menuAuthority[4].enabled !== 1) {

  //           this.errMsg = '権限がありません。';
  //           this.showDialog = true;
  //         } else {
  //           this.showDialog = false;
  //         }

  //         if (res.status === 204) {
  //           this.errMsg = '担当者ログインが行われていません。';
  //           this.showDialog = true;
  //         }
  //         // this.showDialog = false;
  //         // this.planmainService.staffDialogCallback.next(null);
  //         // this.planmainService.menuAuthoCallback.next(true);
  //       }
  //     },
  //       err => {
  //         this.errMsg = 'システムエラーが発生しました。';
  //         this.showDialog = true;
  //       });
  //   } else {
  //     // this.router.navigate(['/fukusha']);
  //     this._planmainService.staffDialogCallback
  //       .takeUntil(this.ngUnsubscribe)
  //       .subscribe(e => {
  //         if (e) {
  //           this._planmainService.getMenuAuthority().take(1).subscribe((res: any) => {
  //             if (res) {
  //               if (res.status === 204) {
  //                 this.errMsg = '担当者ログインが行われていません。';
  //                 this.showDialog = true;
  //               } else {
  //                 this.menuAuthority = res;
  //                 if (this.menuAuthority[4].enabled !== 1) {
  //                   this.errMsg = '権限がありません。';
  //                   this.showDialog = true;
  //                 } else {
  //                   this.showDialog = false;
  //                   this.router.navigate(['/osusume']);
  //                 }
  //               }
  //             }
  //           });
  //           // this.openDialog = false;
  //           // this.router.navigate(['/fukusha']);
  //           // this.onrouterpage();
  //         }
  //       });
  //       this.router.navigate(['/osusume']);
  //   }
  // }

  openpagebusinessmanage() {
    this.display2 = true;
  }

  onrouterpage() {
    this.router.navigate(['/planmain']);
  }

  fukushapage() {
    this.router.navigate(['/fukusha']);
  }

  onbusinessmanage() {
    this.router.navigate(['/business-manage']);
  }

  // onKyotens(event: Kyotens) {
  //   localStorage.setItem('kyotenCd', event.kyotenCd);
  //   localStorage.setItem('kyotenNm', event.kyotenNm);
  // }

  // onstaffs(event: Staffs) {
  //   localStorage.setItem('staffCd', event.staffCd);
  //   localStorage.setItem('staffNm', event.staffNm);
  // }

  resetDataservice() {
    this._planmainService.isPlanFromBusinessManage = false;
    this.planService.currentGrandTotal.next(0);
    this._planmainService.shohiyouKazeiSave.next(null);
    this._planmainService.shohiyouHikazeiSave.next(null);
    this.planService.flagsUsedCar.next(null);
    this.planService.chosenDealerItemSelected.next(null);
    this._planmainService.dopdealarvalue.next(null);
    this.planService.dialogState.next(false);
    this.planService.laborRatePrice.next(0);
    this.planService.savedLaborRatePrice.next(0);
    this.planService.changeLaborRate.next(false);
    this.planService.isLaborSave.next(false);
    this.planService.unsaveLaborRate.next(0);
    // this._planmainService.settotal(0);
    this.planService.hontaiZk.next(0);
    this.planService.hontaiZn.next(0);
    this.planService.isInitialPlan = false;
    this._PlanoneService.onResetData();
    this._PlantwoService.onResetData();
    this._PlanthreeService.onResetData();
    // this._PlanoneService.carAPISubject.next(null);
    // this._PlantwoService.carAPISubject.next(null);
    // this._PlanthreeService.carAPISubject.next(null);
    this._planmainService.addRecycledata(null);
    this._planmainService.addTaxValue(null);
    this._planmainService.setCustomer(null);
    this.planService.customernamesub.next(null);
    this._planmainService.addtradeinData(null);
    this._planmainService.adddopdealarvalue(null);
    // this._planmainService.setDatauseCar(null);
    this._planmainService.setDataHop(null);
    this._planmainService.setdateMop(null);
    this._planmainService.settotal(null);
    this._planmainService.setDatatadeincar(null);
    this._planmainService.setDatatadeincar2(null);
    this._planmainService.setLoanData(null);
    this._planmainService.stockdetail.next(null);
    this.planService.setGradeSelectedForDOP(null);
    this._planmainService.sethanbaitenOption(null);
    this.planService.switchCustomer.next(false);
    this._planmainService.setDataQuotationCustomers(null);
    this.planService.setPriceZk(0);
    this.planService.setPriceZn(0);
    this._planmainService.hopShowDialog.next(false);
    this.planService.changeShohiyou.next(true);
    this._planmainService.isOsusume = false;
    this.planService.pagecheck.next(false);
    this.planService.getPlanUsedcar(null);
    this.planService.setDefaultShohiyouList([]);
    this.planService.setDefaultHikazeiList([]);

    this.clearPlanAndLoanValue();
    this.planService.onresetloan();
    this._data.removeCarData();
    this._data.removeOrderNoMitsumoriNo();
    this._data.removeData('leaseMode');
    if (this._data.staffData) {
      this._data.kyotenCd = this._data.staffData.kyotenCd;
    } else {
      this._data.kyotenCd = null;
    }
    this.planService.chosenKyoten.next({
      kyotenCd: this._data.kyotenCd,
      kyotenNm: this._data.kyotenNm
    });
    this._data.planStaffCd = null;
    this.planService.productKbn.next(0);
    this.planService.selectPaymentWay.next(null);
  }

  onShowNews(code: string) {
    this.shownew = true;
    this.newsService
      .getNewsDetail(code)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        this.newsdetail = data.newsdetail;
      });
  }

  onclose() {
    this.display2 = false;
    this.display = false;
    this.shownew = false;
  }

  onChangePage(p: number) {
    this.page = p;
    this.newsService
      .getNews(this.page)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        this.news = data.newslist;
      });
  }

  // clearPlanAndLoanValue() {
  //   // CLear all grade car
  //   this.planService.isShowBalloon.next(false);
  //   this.planService.loanPlanOneName.next('');
  //   this.planService.loanPlanTwoName.next('');
  //   this.planService.loanOneMonthlyPayment.next(0);
  //   this.planService.loanTwoMonthlyPayment.next(0);
  //   this.planService.loanOneFirstPayment.next(0);
  //   this.planService.loanTwoFirstPayment.next(0);
  //   this.planService.loanOneBonus.next(0);
  //   this.planService.loanTwoBonus.next(0);
  //   this.planService.loanOneBonusCount.next(0);
  //   this.planService.loanTwoBonusCount.next(0);
  //   this.planService.loanTwoBonusCount2.next(0);
  //   this.planService.loanTwoBonusCount3.next(0);
  //   this.planService.setLoanTabs(1);
  //   this.planService.setLoanTabs2(1);
  //   this.planService.setLoanTabs3(1);
  //   this.planService.loanOnePaymentCount.next(0);
  //   this.planService.loanOnePaymentCount2.next(0);
  //   this.planService.loanOnePaymentCount3.next(0);
  //   this.planService.loanTwoPaymentCount.next(0);
  //   this.planService.loanTwoPaymentCount2.next(0);
  //   this.planService.loanTwoPaymentCount3.next(0);
  //   this.planService.leasePlanOneName.next('');
  //   this.planService.leasePlanTwoName.next('');
  //   this.planService.leaseOneFirstPayment.next('0');
  //   this.planService.leaseTwoFirstPayment.next('0');
  //   this.planService.leaseOneMonthlyPayment.next('0');
  //   this.planService.leaseTwoMonthlyPayment.next('0');
  //   this.planService.leaseOneBonus.next(0);
  //   this.planService.leaseTwoBonus.next(0);
  //   this.planService.leaseOneBonusCount.next(0);
  //   this.planService.leaseTwoBonusCount.next(0);
  // }

  clearPlanAndLoanValue() {
    // CLear all grade car

    this.planService.chosenLoanPlan.next(0);
    this.planService.chosenShinpanCode.next('');
    this.planService.chosenShinpanRenban.next(0);
    this.planService.loanGankinHasuuKbn.next(0);
    this.planService.isPlanOneActivated.next(false);
    this.planService.isPlanTwoActivated.next(false);
    this.planService.loanOneAtamakin.next(0);
    this.planService.loanTwoAtamakin.next(0);
    this.planService.loanPlanOneName.next('');
    this.planService.loanPlanTwoName.next('');
    this.planService.loanOneMonthlyPayment.next(0);
    this.planService.loanTwoMonthlyPayment.next(0);
    this.planService.loanOneFirstPayment.next(0);
    this.planService.loanTwoFirstPayment.next(0);
    this.planService.loanOneBonus.next(0);
    this.planService.loanTwoBonus.next(0);
    this.planService.loanOneBonusCount.next(0);
    this.planService.loanTwoBonusCount.next(0);
    this.planService.loanOnePaymentCount.next(0);
    this.planService.loanOnePaymentCount2.next(0);
    this.planService.loanOnePaymentCount3.next(0);
    this.planService.loanTwoPaymentCount.next(0);
    this.planService.loanTwoPaymentCount2.next(0);
    this.planService.loanTwoPaymentCount3.next(0);
    this.planService.loanOneFirstPaymentYM.next('');
    this.planService.loanTwoFirstPaymentYM.next('');
    this.planService.loanOneKappuTesuuRyou.next(0);
    this.planService.loanTwoKappuTesuuRyou.next(0);
    this.planService.loanOneBonusMonthOne.next(0);
    this.planService.loanTwoBonusMonthOne.next(0);
    this.planService.loanOneBonusMonthTwo.next(0);
    this.planService.loanTwoBonusMonthTwo.next(0);
    this.planService.loanOneShinpanRenban.next(0);
    this.planService.loanTwoShinpanRenban.next(0);
    this.planService.loanOneShinpanCode.next('');
    this.planService.loanTwoShinpanCode.next('');
    this.planService.loanOneFirstBonusPaymentYM.next('');
    this.planService.loanTwoFirstBonusPaymentYM.next('');
    this.planService.loanOneIsSueoki.next(0);
    this.planService.loanTwoIsSueoki.next(0);
    this.planService.loanOneSueokiPrice.next(0);
    this.planService.loanTwoSueokiPrice.next(0);
    this.planService.loanOneSueokiRitsu.next(0);
    this.planService.loanTwoSueokiRitsu.next(0);
    this.planService.isShowBalloon.next(false);

    this.planService.loanCreditCompanyOne.next(0);
    this.planService.chosenCreditCompany.next(0);

    this.planService.isShowBalloon.next(false);
    this.planService.isShowBalloon2.next(false);
    this.planService.isShowBalloon3.next(false);
    this.planService.loanPlanOneName.next('');
    this.planService.loanPlanOneName2.next('');
    this.planService.loanPlanOneName3.next('');
    this.planService.loanPlanTwoName.next('');
    this.planService.loanPlanTwoName2.next('');
    this.planService.loanPlanTwoName3.next('');
    this.planService.loanOneMonthlyPayment.next(0);
    this.planService.loanOneMonthlyPayment2.next(0);
    this.planService.loanOneMonthlyPayment3.next(0);
    this.planService.loanTwoMonthlyPayment.next(0);
    this.planService.loanTwoMonthlyPayment2.next(0);
    this.planService.loanTwoMonthlyPayment3.next(0);
    this.planService.loanOneFirstPayment.next(0);
    this.planService.loanOneFirstPayment2.next(0);
    this.planService.loanOneFirstPayment3.next(0);
    this.planService.loanTwoFirstPayment.next(0);
    this.planService.loanTwoFirstPayment2.next(0);
    this.planService.loanTwoFirstPayment3.next(0);
    this.planService.loanOneBonus.next(0);
    this.planService.loanOneBonus2.next(0);
    this.planService.loanOneBonus3.next(0);
    this.planService.loanTwoBonus.next(0);
    this.planService.loanTwoBonus2.next(0);
    this.planService.loanTwoBonus3.next(0);
    this.planService.loanOneBonusCount.next(0);
    this.planService.loanOneBonusCount2.next(0);
    this.planService.loanOneBonusCount3.next(0);
    this.planService.loanTwoBonusCount.next(0);
    this.planService.loanTwoBonusCount2.next(0);
    this.planService.loanTwoBonusCount3.next(0);
    this.planService.setLoanTabs(1);
    this.planService.setLoanTabs2(1);
    this.planService.setLoanTabs3(1);
    this.planService.loanOnePaymentCount.next(0);
    this.planService.loanOnePaymentCount2.next(0);
    this.planService.loanOnePaymentCount3.next(0);
    this.planService.loanTwoPaymentCount.next(0);
    this.planService.loanTwoPaymentCount2.next(0);
    this.planService.loanTwoPaymentCount3.next(0);
    this.planService.setShitadori.next(0);
    this.planService.setCar1ShitadoriKbn.next(1);
    this.planService.setCar2ShitadoriKbn.next(1);
    this.planService.chosenGradeSelected.next('');
  }

  onCloseDialog(event) {
    if (event) {
      this.openDialog = event.status;
      if (event.statusclick === 1) {
        this.showEstimates = true;
      } else if (event.statusclick === 2) {
        this.showDialogOrder = true;
      }
    }
    this._planmainService.staffDialogCallback.next(false);
  }

  oncloseDialogSearch(event) {
    this.showEstimates = false;
    this.showDialogOrder = false;
  }

  onchumonData(event) {
    this.showEstimates = false;
    this.showDialogOrder = false;
    this._data.removeData('mitsumorino');
    this._data.saveData('ordersNo', event);
    this.router.navigate(['/planmain']);
  }

  ongetvaluemistsumor(event) {
    this.showEstimates = false;
    this.showDialogOrder = false;
    this._data.removeData('ordersNo');
    this._data.saveData('mitsumorino', event);
    this.router.navigate(['/planmain']);
  }

  onCloseMessage(e) {
    this.showDialog = false;
  }
  onCloseDialogStock(e) {
    this.openDialogStock = false;
  }

  openAfterLogin(res, isClick: string) {
    this.menuAuthority = res;
    if (this.menuAuthority[4].enabled !== 1) {
      this.errMsg = '権限がありません。';
      this.showDialog = true;
    } else {
      this.showDialog = false;
      if (isClick === 'osusume') {
        this.router.navigate(['/osusume']);
      } else if (isClick === 'stock') {
        this.openDialogStock = true;
        // this.router.navigate(['/usedcar']);
      } else {
        this.openDialog = true;
      }
    }
  }

  onSubmitSearchStock(data) {
    this._planmainService.stockSelected.next(data);
    this.router.navigate(['/planmain']);
  }

  onOpenNewsDetail(data: any) {
    this.showNewsDetail = true;
    this.showNews = data;
  }

  onCloseNewsDetail() {
    this.showNewsDetail = false;
  }

  getNewsList() {
    this.newsService
      .getNewsListUser(this.newsPage, 10, '-date,-id')
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        if (data) {
          data.results.map(res => {
            res.bodyFull = res.body;
            res.body = res.body.replace(/\\n/g, " ");
            const titleLength = this._util.getUTF8Length(res.body, 100);
            if (titleLength.count > 100) {
              res.body = res.body.substr(0, titleLength.strCount) + "...";
            } else {
              res.body = res.body;
            }
          });
          this.newsList = data.results;
          this.totalPages = data.totalPages;
          this.countNews = data.results.length;
        } else {
          this.newsList = [];
          this.totalPages = 0;
          this.countNews = 0;
        }
      });
  }

  prevPage() {
    if (this.newsPage > 1) {
      this.newsPage -= 1;
      this.getNewsList();
    }
  }

  nextPage() {
    if (this.newsPage < this.totalPages) {
      this.newsPage += 1;
      this.getNewsList();
    }
  }

  setLoader(loader: boolean) {
    this.loader = loader;
  }

  changeText1(menu: number) {
    if (menu == 1) {
      this.textContent1 = this.newcarText;
    } else if (menu == 2) {
      this.textContent1 = this.planText;
    } else if (menu == 3) {
      this.textContent1 = this.stockText;
    } else if (menu == 4) {
      this.textContent1 = "カーベル新車市場が提供する<br>もっとも安くてお得な車の買い方<br>毎月変わる福を呼ぶ車「福車」や<br>月々定額で車に乗れるプランなど<br>お客様のニーズに応えます。";
    }
  }

  changeText2(menu: number) {
    if (menu == 1) {
      this.textContent2 = '全国のコレCARラネットワークの共有在庫から簡単見積り、注文書作成ができます。';
    } else if (menu == 2) {
      this.textContent2 = this.planText;
    } else if (menu == 3) {
    this.textContent2 = this.stockText;
    }
  }

  changeText3(menu: number) {
    if (menu == 1) {
      this.textContent3 = this.newcarText;
    } else if (menu == 2) {
      this.textContent3 = this.planText;
    }
  }

  resetText() {
    this.textContent1 = "";
    this.textContent2 = "";
    this.textContent3 = "";
  }

  directGoToPage(page: string) {
    this.router.navigate([`/${page}`]);
  }

  downloadManual(fileName: string) {
    if (fileName) {
      this.loader = true;
      this._planmainService.downloadManual(encodeURIComponent(fileName)).subscribe(
        res => {
          if (res) {
            const blob = new Blob([res], { type: 'application/pdf' });
            saveAs(blob, fileName + '.pdf');
          }
          setTimeout(() => {
            this.loader = false;
          }, 500);
        },
        err => {
          this.loader = false;
          console.error(`download ${fileName} fail`);
        }
      );
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/home/home.component.ts